import {useEffect} from "react"
import {useAppSelector, useAppDispatch} from "../redux/Hooks"
import AddAssistantForm from "./AddUser/AddAssistantForm"
import AddAdminForm from "./AddUser/AddAdminForm"
import type {RootState} from "../redux/Store"
import {setPage} from "../redux/User/UserSlice"
import {isAdmin} from "../utils/UserTools"
import PageHeader from "./PageHeader"

export default function UserProfile() {

    const dispatch = useAppDispatch()
    const roles = useAppSelector((state: RootState) => state.app.roles)

    useEffect(() => {
        dispatch(setPage("my-profile"))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <PageHeader title="Mon profil" breadcrumb/>
            <div className="container">
                <div className="block">
                    <h3 className="text-primary">Informations générales</h3>
                    {
                        isAdmin(roles) ?
                            <AddAdminForm editMode={true} pageProfil={true}/> :
                            <AddAssistantForm editModeAssistant={true} pageProfil={true}/>
                    }
                </div>
            </div>
        </>
    )
}
